<template>
  <v-container xs12 fluid class="pt-0">
    <v-card class="pa-2 card-r pb-4 shadow-1">
      <v-toolbar class="primary darken-2 card-r pl-3 text-white">
        <div class="text-xs-left f-20">Students</div>
      </v-toolbar>
      <v-layout mt-2>
        <v-flex>
          <v-card class="grey lighten-4 mt-3 pa-2 shadow-1 text-xs-center">
            <v-flex xs12 lg6 class="ma-auto pb-3 pt-2 hide-pro pro">
              <v-text-field solo append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
            </v-flex>
            <v-data-table :search="search" v-if="StudentList.Students" :headers="headers" :items="StudentList.Students" class="  card-r no-shadow laptop-data-table">
              <template slot="items" slot-scope="props">
                <td class="word-break text-xs-left">{{ props.item.name }}</td>
                <td v-if="props.item.teacher" class="word-break text-xs-left">{{  props.item.teacher.name}}</td>
                <td v-if="!props.item.teacher" class="text-xs-left">-</td>
                <td class="text-xs-left">+45{{ props.item.phone }}</td>
                <td class="word-break text-xs-left">{{ props.item.email }}</td>
                <td class="text-xs-left">{{ props.item.gender }}</td>
                <td><div v-if="props.item.status" class="pro pt-2 hide-pro">
                    <v-select solo v-model="props.item.status" :items="teacherStatus" item-text="props.item.status"
                              item-value="props.item.status" @change=changestatus(props.item.id,props.item.status)
                              persistent-hint return-object single-line></v-select></div>
                </td>
                <td class="layout px-0">
                  <v-btn class="shadow-1" icon v-bind:to="'/students/edit/'+props.item.id">
                    <v-icon class="grey--text f-12 text-green">fa-edit</v-icon>
                  </v-btn>
                  <v-btn class="shadow-1" icon v-bind:to="'/studentprofile/'+props.item.id">
                    <v-icon class="grey--text f-12 text-green" to="/teacherprofile">fa-sign-in-alt</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <v-data-table :search="search" v-if="StudentList.Students" :headers="[]" :items="StudentList.Students" class="  card-r no-shadow mobile-data-table">
            <template slot="items" slot-scope="props">
              <v-card class="mb-3 grey lighten-3 pa-3 pt-4 no-shadow card-r">
                <v-flex><span class="font-weight-bold mr-1">Name:</span> {{ props.item.name }}</v-flex>
                <v-flex>
                  <div v-if="props.item.teacher"><span class="font-weight-bold mr-1">Teacher Name:</span> {{  props.item.teacher.name}}</div>
                  <div v-if="!props.item.teacher"><span class="font-weight-bold mr-1"> Teacher Name:</span> -</div>
                </v-flex>
                <v-flex><span class="font-weight-bold mr-1">Phone : </span>+45{{ props.item.phone }}</v-flex>
                <v-flex><span class="font-weight-bold mr-1"> Email :</span> {{ props.item.email }}</v-flex>
                <v-flex><span class="font-weight-bold mr-1">Gender : </span>{{ props.item.gender }}</v-flex>
                <v-flex class="text-xs-right">
                  <v-btn icon v-bind:to="'/studentprofile/'+props.item.id">
                    <v-icon class="grey--text" to="/teacherprofile">fas fa-sign-in-alt
                    </v-icon>
                  </v-btn>
                  <v-btn icon v-bind:to="'/students/edit/'+props.item.id">
                    <v-icon class="grey--text">fa-edit</v-icon>
                  </v-btn>
                </v-flex>
              </v-card>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
  <!--<add-new-student/>-->
</template>
<script>
  /* eslint-disable */
  import AddNewStudent from "./AddNewStudent.vue"
  import { setTimeout } from 'timers'
  import { mapState } from 'vuex'
  export default {
    name: "Students",
    data() {
      return {
        search: '',
        headers: [
          { text: "NAME", value: "name" },
          { text: "TEACHER NAME", value: "teachername" },
          { text: "CONTACT", value: "phone" },
          { text: "EMAIL", value: "email" },
          { text: "GENDER", value: "gender" },
          { text: "STATUS", value: "status" },
          { text: "ACTIONS", value: "" },
          // { text: "", value: "" }
        ],
        // StudentList:[],
        teacherStatus:["active","inactive",'blocked']
      };
    },
    created(){
      Store.commit("setLoading", { loading: true });
      Store.dispatch("Students/getAllStudents")
      Store.commit("setLoading", { loading: false });
      // .then(res => {
      //   setTimeout(function(){
      //     this.StudentList = res;
      //     Store.commit("setLoading", { loading: false });
      //   },1000)
      // })
      // .catch(() => {
      //   Store.commit("setLoading", { loading: false });
      // });
      setTimeout(() => {
      }, 2000);
    },
    methods:{
      changestatus(studentid,status) {
        //
        var Data={
          "studentid":studentid,
          "status":status
        }
        this.$store.dispatch("Students/changeStudentStatus", Data)
      }
    },
    computed:{
      ...mapState({
        StudentList:"Students"
      })
    },
    components: {
      AddNewStudent
    }
  };
</script>
<style>
  .v-select__slot div{
    font-size: 13px !important;
    border:none
  }
  .v-text-field.v-input--is-focused .v-input__slot:after{
    display:none !important;
  }
  .v-text-field>.v-input__control>.v-input__slot:before{
    display: none !important;
  }
  /*##Device = Desktops##Screen = 1281px to higher resolution desktops*/
  @media (min-width: 1281px) {
    .mobile-data-table{
      display: none
    }
    .laptop-data-table{
      display: block
    }
  }
  /*##Device = Laptops, Desktops##Screen = B/w 1025px to 1280px*/
  @media (min-width: 1025px) and (max-width: 1280px) {
    .mobile-data-table{
      display: none
    }
    .laptop-data-table{
      display: block
    }
  }
  /*##Device = Tablets, Ipads (landscape)##Screen = B/w 768px to 1024px*/
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    .mobile-data-table{
      display: none
    }
    .laptop-data-table{
      display: block
    }
  }
  /*##Device = Low Resolution Tablets, Mobiles (Landscape)##Screen = B/w 481px to 767px*/
  @media (min-width: 481px) and (max-width: 767px) {
    .mobile-data-table{
      display: block
    }
    .laptop-data-table{
      display: none
    }
  }
  /*##Device = Most of the Smartphones Mobiles (Portrait)##Screen = B/w 320px to 479px*/
  @media (min-width: 320px) and (max-width: 480px) {
    .mobile-data-table{
      display: block
    }
    .laptop-data-table{
      display: none
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/student/Students.vue